import { useEffect, useState } from 'react';
import { onCacheStale } from '../utils/cache/axiosCache';

/**
 * A small pill shown whenever a request was answered from disk instead of the
 * network. It tells the user the screen is real but not live, which is the
 * honest alternative to a blank page — and removes the reflex to hit refresh.
 *
 * Bottom-left on purpose: a full-width top strip would sit on top of the
 * custom Electron titlebar (blocking window drag on Windows), and a bottom
 * strip would cover the chat composer.
 */
export default function CacheStaleBanner() {
  const [stale, setStale] = useState(false);

  useEffect(() => onCacheStale(setStale), []);

  if (!stale) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: 12,
        left: 12,
        zIndex: 9999,
        padding: '5px 12px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 500,
        color: '#7a4b00',
        background: '#ffe8b3',
        border: '1px solid #f0c96a',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.18)',
        pointerEvents: 'none',
      }}
    >
      Reconnecting… showing saved data
    </div>
  );
}
